import expandingIntoEurope from './expanding_into_europe.json'

export default expandingIntoEurope
